import React from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';
import { Row, Col } from 'react-flexbox-grid';
import cn from 'classnames';

import Logo from '../event_components/logo';
import Title from '../event_components/title';
import Location from '../event_components/location';
import Time from '../event_components/time';
import Details from '../event_components/details';
import AttendButton from '../event_components/attend_button';
import styles from './large-list.scss';

import MobileLayout from './mobile';
import GoogleLocation from '../event_components/google_location';
import EventStatus from '../event_components/event_status';

const propTypes = {
  event: PropTypes.instanceOf(Map).isRequired,
  settings: PropTypes.instanceOf(Map).isRequired,
  index: PropTypes.number,
};

// eslint-disable-next-line react/prop-types
function LogoContainer({ event, settings }) {
  return (
    <Col xs={6} md={6}>
      <div className={styles.image}>
        <Logo event={event} settings={settings} />
      </div>
    </Col>
  );
}
// eslint-disable-next-line react/prop-types
function DetailsContainer({ event, settings }) {
  return (
    <Col xs={6} md={6} className={styles.details}>
      <div className={styles.info}>
        <div className={styles.inline}>
          <Time event={event} settings={settings} format="ddd D MMM YYYY" withIcon />
          <span className="date" style={{ marginRight: 10 }}>
            |
          </span>
          {settings.get('calendarType') === 'google' ? (
            <GoogleLocation event={event} />
          ) : (
            <Location event={event} className={styles.location} />
          )}
        </div>
        <Title event={event} className={styles.title} />
        {settings.get('showEventStatus') && <EventStatus event={event} settings={settings} />}
        <Details event={event} settings={settings} />
        {!settings.get('removeAttendButton') && (
          <AttendButton settings={settings} event={event} className={styles.button} />
        )}
      </div>
    </Col>
  );
}

export function LargeListEvent({ event, settings, index }) {
  const isEven = index % 2 === 0;
  const LeftSideComponent = isEven ? LogoContainer : DetailsContainer;
  const RightSideComponent = isEven ? DetailsContainer : LogoContainer;

  return (
    <Row className={cn(styles.list, 'event')}>
      <LeftSideComponent event={event} settings={settings} />
      <RightSideComponent event={event} settings={settings} />
    </Row>
  );
}

LargeListEvent.propTypes = propTypes;

function ListContainer({ events, settings, isMobile }) {
  const Component = isMobile ? MobileLayout : LargeListEvent;
  return (
    <div>
      {events.map((event, index) => (
        <Component key={event.get('id')} event={event} settings={settings} index={index} />
      ))}
    </div>
  );
}

ListContainer.propTypes = {
  events: PropTypes.instanceOf(Map).isRequired,
  settings: PropTypes.instanceOf(Map).isRequired,
  isMobile: PropTypes.bool,
};

export default ListContainer;



// WEBPACK FOOTER //
// ./src/widget/event_layouts/large-list.js